import CreateUser from './views/CreateUser.vue'
import ListUsers from './views/ListUsers.vue'
import HomeLayout from '@/layouts/Home.vue'
import UserDetail from './views/UserDetail.vue'

export const userRoutes = [
  {
    path: '/users',
    name: 'users',
    component: ListUsers,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/users/add',
    name: 'users/add',
    component: CreateUser,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/users/:username',
    name: 'users/detail',
    component: UserDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
]
